import LoanService from '@/service/loan/LoanService'

import router from '@/router'

export default [{
  name: 'loan/confirm',
  path: '/loan/confirm',
  async beforeEnter(to, from, next) {
    let canLoan = LoanService.canLoan()
    if (!canLoan) {
      let alert = await window.$swal.fire({
        html: '대출 접수 가능한 상태가 아닙니다',
        icon: 'warning',
        confirmButtonText: '확인'
      })
      if (alert.isConfirmed) {
        router.push({ name: 'dashboard' })
        return
      }
    }

    let isLoanContractDisable = await LoanService.isLoanContractDisable()
    if (isLoanContractDisable) {
      let alert = await window.$swal.fire({
        html: '계약서를 작성 가능한 시간이 아닙니다',
        icon: 'warning',
        confirmButtonText: '확인'
      })
      if (alert.isConfirmed) {
        router.push({ name: 'dashboard' })
        return
      }
    }
    next()
  },
  component: require('@/views/loan/LoanConfirm.vue').default
}, {
  name: 'loan/contract',
  path: '/loan/:uuid/contract',
  component: require('@/views/loan/LoanDetailContract.vue').default
}]
